import {connect} from 'react-redux';
import * as comparableListingsActions from 'actionCreators/comparableListings';
import * as comparableRentalsActions from 'actionCreators/comparableRentals';
import * as comparableSalesActions from 'actionCreators/comparableSales';
import FeaturedComparable from 'components/FeaturedComparable';
import {getMarkers} from 'lib/MapUtil';
import {comparableListingUpdateFields, getCompItemTitlePrice, getIsFieldVisible} from 'lib/PropertyUtils';
import {COMPARABLE_TYPES} from '../constants/comparableTypes';

const mapStateToProps = (state, {propertyId, comparableType}) => {
  const comparableItems = {
    sales: state.comparableSales,
    listings: state.comparableListings,
    rentals: state.comparableRentals,
  }[comparableType];
  const property = comparableItems.properties[propertyId] || {};
  const { displayFields = {} } = property;

  const marker = getMarkers(state, comparableType).find(({id}) => id === propertyId);

  let selectedPhotoIndex = [];
  if (property.featuredPhotos) {
    selectedPhotoIndex = [...property.featuredPhotos];
  } else if (property.propertyPhotoList) {
    selectedPhotoIndex = [...property.propertyPhotoList];
  }
  selectedPhotoIndex = [...selectedPhotoIndex, null, null, null].slice(0, 3);
  selectedPhotoIndex = selectedPhotoIndex
    .map((name, i) => {
      if (name === '') {
        return property.propertyPhotoList.length;
      }
      const idx = property.propertyPhotoList ? property.propertyPhotoList.indexOf(name) : -1;
      return idx === -1 ? i : idx;
    });

  const isPriceDescriptionVisible = getIsFieldVisible('salePrice', displayFields);

  return {
    comparableType,
    singleLineAddress: property.singleLineAddress,
    bedrooms: property.bedrooms,
    bedroomsIsEdited: property.bedroomsIsEdited,
    bathrooms: property.bathrooms,
    bathroomsIsEdited: property.bathroomsIsEdited,
    carSpaces: property.carSpaces,
    carSpacesIsEdited: property.carSpacesIsEdited,
    landArea: property.landArea,
    landAreaIsEdited: property.landAreaIsEdited,
    floorArea: property.floorArea,
    floorAreaIsEdited: property.floorAreaIsEdited,
    price: getCompItemTitlePrice(comparableType, property),
    date: property.saleDate,
    photos: property.propertyPhotoList ?? [],
    daysOnMarket: property.daysOnMarket,
    distance: property.distance,
    yearBuilt: property.yearBuilt,
    firstAdvertisementPrice: property.firstAdvertisementPrice,
    latestAdvertisementPrice: property.latestAdvertisementPrice,
    firstPublishedPrice: property.firstPublishedPrice,
    firstPublishedPriceIsEdited: property.firstPublishedPriceIsEdited,
    latestPublishedPrice: property.latestPublishedPrice,
    latestPublishedPriceIsEdited: property.latestPublishedPriceIsEdited,
    displayFields,
    isPriceDescriptionVisible,
    capitalValue: property.capitalValue,
    markerLabel: marker ? marker.label : null,
    salePriceIsEdited: property.salePriceIsEdited,
    saleDateIsEdited: property.saleDateIsEdited,
    selectedPhotoIndex: selectedPhotoIndex,
    deletableImages: property.uploadPhotoList,
    featureFlags: state.featureFlags,
  };
};

const ducks = {
  [COMPARABLE_TYPES.sales]: comparableSalesActions,
  [COMPARABLE_TYPES.listings]: comparableListingsActions,
  [COMPARABLE_TYPES.rentals]: comparableRentalsActions,
};

const mapDispatchToProps = (dispatch, {propertyId, comparableType}) => {
  const duck = ducks[comparableType];
  const onPriceDescriptionClick = (event) => {
    dispatch(comparableListingsActions.setDisplayField({
      propertyId,
      fieldName: comparableListingUpdateFields,
      descriptiveFieldName: 'Price Description',
      visible: event.target.checked,
    }));
  };

  return {
    onSelectPhoto: (index, value) => dispatch(duck.updateForSession({
      propertyId,
      keyPath: ['featuredPhotos', index],
      value: value || ''
    }, true)),
    onRemoveFeature: () => dispatch(duck.removeFeatureProperty(propertyId)),
    onRemoveSelected: () => dispatch(duck.removeSelectedItem(propertyId)),
    onUpload: (featuredIndex, files) => dispatch(duck.uploadComparableImage(propertyId, files[0], featuredIndex)),
    onDelete: (currentImageIndex) => dispatch(duck.deleteUploadedImage(propertyId, currentImageIndex)),
    onPriceDescriptionClick,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedComparable);
